// extracted by mini-css-extract-plugin
module.exports = {"button":"LoginPage_button__2lDQY","content":"LoginPage_content__1fKJT","loading":"LoginPage_loading__3ckrA","container":"LoginPage_container__2Lk2P"};